import { FoodListDivider } from "components/foodItem/FoodListItem/styled"
import MealListItem from "components/foodItem/MealListItem"
import { FlexBox } from "components/Common/FlexBox"
import { DotLoading, InfiniteScroll, SpinLoading } from "antd-mobile"
import { MealType } from "model/food/types"
import styled from "styled-components"
import { RecentMealsWrapper } from "./styled"

const InfinitiScrollContent = ({
  isFirstLoad,
  isLoading,
  hasMore,
}: {
  isFirstLoad: boolean
  isLoading: boolean
  hasMore: boolean
}) => {
  if (isFirstLoad) {
    return (
      <FlexBox $alignItems="center" $justify="center" style={{ height: 200 }}>
        <SpinLoading />
      </FlexBox>
    )
  }

  if (hasMore) {
    return isLoading ? (
      <FlexBox
        style={{ height: 40, width: "100%" }}
        $justify="center"
        $alignItems="center"
      >
        {" "}
        <span>Loading more food</span>
        <DotLoading />
      </FlexBox>
    ) : null
  }

  return "All foods found"
}

const Title = styled.div`
  line-height: 22px;
  font-size: 14px;
  font-weight: 700;
`

const RecentMealsContent = styled.div`
  --title-height: 22px;
  overflow-y: auto;
  height: calc(100% - var(--title-height));
`

const RecentMeals = ({
  meals,
  loadMore,
  loading,
  hasMore,
  onSelectMeal,
  handleLogMealFromMeal,
}: {
  meals: MealType[]
  loadMore: any
  loading: boolean
  hasMore: boolean
  onSelectMeal: (meal: MealType) => void
  handleLogMealFromMeal: (meal: MealType) => void
}) => {
  return (
    <RecentMealsWrapper>
      <Title>Recent</Title>
      <RecentMealsContent>
        {meals.map((meal, index) => (
          <div key={meal.id + index}>
            {" "}
            <MealListItem
              onSelect={() => onSelectMeal(meal)}
              meal={meal}
              onAdd={(meal) => {
                handleLogMealFromMeal({ ...meal, type: undefined })
              }}
            />
            {index !== meals.length - 1 && <FoodListDivider />}
          </div>
        ))}
        <InfiniteScroll loadMore={loadMore} hasMore={hasMore}>
          <InfinitiScrollContent
            hasMore={hasMore}
            isLoading={loading}
            isFirstLoad={!meals.length}
          />
        </InfiniteScroll>
      </RecentMealsContent>
    </RecentMealsWrapper>
  )
}

export default RecentMeals
